import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';
import { List } from 'lodash';

interface LabFeedbackState {
    MachineUsage?:any,
    SystemUsage?:any,
}
  
const initialState:LabFeedbackState = {
    MachineUsage:[],
    SystemUsage:[]   
}

export const LabFeedbackSlice = createSlice({
    name:"labFeedbacks",
    initialState,
    reducers:{
        UpdateLabFeedback: (state,action) => {
            state.MachineUsage = action.payload.MachineUsage;
            state.SystemUsage = action.payload.SystemUsage;
        },
        AddLabFeedback: (state,action) => (
            initialState
        ),
        EditLabFeedback: (state,action) => (
            initialState
       ),
        RemoveLabFeedback: (state,action) => (
            initialState
        )
    }
})

export const {UpdateLabFeedback,AddLabFeedback,EditLabFeedback,RemoveLabFeedback} = LabFeedbackSlice.actions

export const selectLabFeedback = (state: RootState) => state.labFeedbacks

export default LabFeedbackSlice.reducer;